module.exports = __webpack_public_path__ + "static/god-emperor-of-dune-ad8f8ef7f73695ad1353273d60899a0f.jpg";